/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	ErrorMessage,
	ErrorMessageFromJSON,
	ErrorMessageFromJSONTyped,
	ErrorMessageToJSON,
} from "./ErrorMessage";
import {
	ExternalAcademicUserLoginResponseDTO,
	ExternalAcademicUserLoginResponseDTOFromJSON,
	ExternalAcademicUserLoginResponseDTOFromJSONTyped,
	ExternalAcademicUserLoginResponseDTOToJSON,
} from "./ExternalAcademicUserLoginResponseDTO";

/**
 *
 * @export
 * @interface ExternalAcademicUserLoginResponseDTORequestResponse
 */
export interface ExternalAcademicUserLoginResponseDTORequestResponse {
	/**
	 *
	 * @type {ExternalAcademicUserLoginResponseDTO}
	 * @memberof ExternalAcademicUserLoginResponseDTORequestResponse
	 */
	response?: ExternalAcademicUserLoginResponseDTO;
	/**
	 *
	 * @type {ErrorMessage}
	 * @memberof ExternalAcademicUserLoginResponseDTORequestResponse
	 */
	errorMessage?: ErrorMessage;
}

export function ExternalAcademicUserLoginResponseDTORequestResponseFromJSON(
	json: any
): ExternalAcademicUserLoginResponseDTORequestResponse {
	return ExternalAcademicUserLoginResponseDTORequestResponseFromJSONTyped(
		json,
		false
	);
}

export function ExternalAcademicUserLoginResponseDTORequestResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ExternalAcademicUserLoginResponseDTORequestResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		response: !exists(json, "response")
			? undefined
			: ExternalAcademicUserLoginResponseDTOFromJSON(json["response"]),
		errorMessage: !exists(json, "errorMessage")
			? undefined
			: ErrorMessageFromJSON(json["errorMessage"]),
	};
}

export function ExternalAcademicUserLoginResponseDTORequestResponseToJSON(
	value?: ExternalAcademicUserLoginResponseDTORequestResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		response: ExternalAcademicUserLoginResponseDTOToJSON(value.response),
		errorMessage: ErrorMessageToJSON(value.errorMessage),
	};
}
